import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_staff/places/_layout/settings/')({
  beforeLoad: () => {
    throw redirect({ to: '/places/settings/place-sub-codes' });
  },
});
